import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_2 = { class: "form-wrapper slide-up select-employees" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "select-employees-count" }
const _hoisted_5 = { class: "select-employees-list" }
const _hoisted_6 = {
  key: 0,
  class: "select-employees-empty"
}
const _hoisted_7 = ["onUpdate:modelValue", "disabled"]
const _hoisted_8 = {
  key: 0,
  class: "select-employees-sub"
}
const _hoisted_9 = {
  key: 1,
  class: "select-employees-sub"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "×")
          ]),
          _createElementVNode("h3", null, _toDisplayString(_ctx.title || 'Employees'), 1),
          _withDirectives(_createElementVNode("input", {
            id: "select-employees-search",
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQ) = $event)),
            placeholder: "Search"
          }, null, 512), [
            [_vModelText, _ctx.searchQ]
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.selectedCount) + " selected", 1),
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.filtered.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "No employees match."))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtered, (emp) => {
              return (_openBlock(), _createElementBlock("label", {
                key: emp.ID,
                class: _normalizeClass(['checkbox-input', 'select-employees-row', { locked: emp.locked }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": ($event: any) => ((emp.selected) = $event),
                  disabled: emp.locked
                }, null, 8, _hoisted_7), [
                  [_vModelCheckbox, emp.selected]
                ]),
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(emp.Name), 1),
                  (emp.SeatTitle)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, " · " + _toDisplayString(emp.SeatTitle), 1))
                    : _createCommentVNode("", true),
                  (emp.locked)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " · " + _toDisplayString(_ctx.lockedNote || 'Can\'t be removed'), 1))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            }), 128))
          ]),
          _createElementVNode("input", {
            type: "submit",
            value: "Save",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.save()), ["prevent"]))
          })
        ])
      ]))
    : _createCommentVNode("", true)
}